import { t } from "i18next";
import React from "react";

const ShowRange = ({ focusedStartDate, focusedEndDate }) => {
  return (
    <>
      <div className="hayley-flex hayley-h-20 hayley-w-full hayley-items-center hayley-justify-between hayley-border hayley-border-b-0 hayley-border-solid hayley-border-custom-6 hayley-bg-white hayley-p-4">
        <div className=" hayley-w-[45%]">
          <p className="hayley-m-0 hayley-p-0 hayley-text-sm hayley-text-secondary/80">{t("startDate")}</p>
          <p className="hayley-my-1 hayley-w-full hayley-border hayley-border-solid hayley-border-custom-6 hayley-p-1 hayley-text-sm">
            {focusedStartDate?.format("MMM DD, YYYY") || "--"}
          </p>
        </div>
        <div className=" hayley-w-[45%]">
          <p className="hayley-m-0 hayley-p-0 hayley-text-sm hayley-text-secondary/80">{t("endDate")}</p>
          <p className="hayley-my-1 hayley-w-full hayley-border hayley-border-solid hayley-border-custom-6 hayley-p-1 hayley-text-sm">
            {focusedEndDate?.format("MMM DD, YYYY") || "--"}
          </p>
        </div>
      </div>
    </>
  );
};

export default ShowRange;
